import styles from './confirmationModal.scss';
import React from 'react';
import Loader from '../../commons/loader/loader';
import Modal from '../../commons/modal/modal';

const ConfirmationModal = ({
  showModal,
  title,
  closeModal,
  confirm,
  reject,
  heading,
  showLoader,
  minWidth
}) => {
  return (
    <Modal
      minWidth={minWidth ? minWidth : ''}
      showModal={showModal}
      title={title}
      closeModal={() => {
        if (closeModal) {
          if (showLoader) {
            return;
          }
          closeModal();
        }
      }}
    >
      <div className={styles.submitModal}>
        {showLoader ? (
          <div style={{ margirnTop: '2rem' }}>
            <Loader />
          </div>
        ) : (
          <>
            <h5>{heading}</h5>
            <div className={styles.buttonWrapper}>
              <button
                className="action-button-white-background-orange-border"
                onClick={reject}
                disabled={showLoader}
              >
                NO
              </button>
              <button
                className="action-button"
                onClick={confirm}
                disabled={showLoader}
              >
                YES
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
